function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9 16s-3.872-.433-6 0-2-1-1.485-3C2.073 10.835 6 12 8 10s5.508-1.73 6.508-.73C17.058 11.818 11.653 24.257 19 23c4.162-.193 7.217-14.056 11-16 2.965-1.523 2.68 8.3 6 8 2.97-.267 3.347-7.624 6.317-7.892 3.32-.3 2.781 5.98 4.707 8.7C48.412 17.771 49.68 22.618 50 25c.42 3.135-3.224 5.846-3 9 .159 2.23 3 6 3 6l-4 14s-6.03.839-6.03-.161C39.97 51.895 44 52 44 52s3.58-9.443 1.407-11.616C40.407 35.384 40 30 40 30c-3.156 4.151-8.201 5.054-15 0l1 9.6L25 54s-6.253 1.303-5.431-.208C20 53 21 52 23 51.6c0-6.6 0-11.6-.539-13.3C21.533 35.373 21 36 20 31c0 0-3 1-6.276.377C9.824 30.635 8 24 9 16z"
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(90)",
  cx: 11.392,
  cy: -10.407,
  rx: 0.515,
  ry: 0.877,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.9 24c.254 4.212.67 8.313 4.1 7M38 32c0 4 1 5 2 8l-2 11s-2 0-4 2c-1.414 1.414 6 0 6 0l4-14M16 31.5c.369 4.098 1.601 6.303 3 8.5v10s-2.838.084-3.838 2.084C14.529 53.35 21 52 21 52l1-15"
})), /*#__PURE__*/React.createElement("path", {
  d: "M13 9s2.045-2.73 3-2c.838.64-1 3-1 3M6 13c.36.96-2.546 1.448-5 2"
}));

var SvgCamel = function SvgCamel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCamel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Camel.252f15c8.svg";
export { ForwardRef as ReactComponent };